<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div class="user-profile">
  <!-- ============================================================== -->
  <!-- Profile - style you can find in header.scss -->
  <!-- ============================================================== -->
  <div class="profile-text">
    <a [matMenuTriggerFor]="sdprofile" class="">
      @if (UserData && UserData.Person) {
      <span>{{UserData.Person.firstName}} {{UserData.Person.infix}} {{UserData.Person.lastName}}</span>
      }
      @if (!UserData) {
      <span>Onbekend</span>
      }
      <i class="ti-angle-down font-12 m-l-5"></i>
    </a>
  </div>
  <mat-menu #sdprofile="matMenu" class="mymegamenu">
    <button [routerLink]="['general/instellingen']" mat-menu-item>
      <mat-icon>settings</mat-icon> Instellingen
    </button>
    <button (click)="logout()" [routerLink]="['/', 'authentication/logout']" mat-menu-item>
      <mat-icon>exit_to_app</mat-icon> Uitloggen
    </button>
  </mat-menu>
</div>
<mat-nav-list appAccordion>
  @for (menuitem of menuItems.getMenuitem(); track menuitem) {
  <mat-list-item class="sidebar-menu-item" appAccordionLink group="{{menuitem.state}}">
    @if (menuitem.type === 'link') {
    <a appAccordionToggle [routerLink]="[menuitem.state]" routerLinkActive="selected">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name }}</span>
      <span style="flex: 1 1 auto;"></span>
      @for (badge of menuitem.badge; track badge) {
      <span class="label label-{{ badge.type }}">{{ badge.value }}</span>
      }
      @if (menuitem.state === '/general/notificaties' && notificationUnreadCount > 0) {
      <span class="notif-badge notif-badge--red">{{ notificationUnreadCount }}</span>
      }
    </a>
    }
    @if (menuitem.type === 'sub') {
    <a appAccordionToggle routerLinkActive="selected">
      <mat-icon>{{ menuitem.icon }}</mat-icon>
      <span>{{ menuitem.name }}</span>
      <span style="flex: 1 1 auto;"></span>
      @for (badge of menuitem.badge; track badge) {
      <span class="label label-{{ badge.type }}">{{ badge.value }}aa</span>
      }
      <mat-icon class="dd-icon">keyboard_arrow_down</mat-icon>
    </a>
    }
    @if (menuitem.type === 'sub') {
    <mat-nav-list class="sub-item">
      @for (childitem of menuitem.children; track childitem) {
      <mat-list-item class="sub-item-a" routerLinkActive="selected">
        <a class="relative" [routerLink]="[menuitem.state, childitem.state ]">
          <span>{{childitem.name}}</span>
          @if (menuitem.showAmount == true && childitem.showAmount == true && childitem.amount != null) {
            @if (childitem.name == 'Spoed') {
              <span class="notif-badge notif-badge--sub" [class.notif-badge--urgent]="urgentValuations">
                {{childitem.amount | number:'0.0-0'}} / {{childitem.amountTotal | number:'0.0-0'}}
              </span>
            } @else {
              <span class="notif-badge notif-badge--sub">{{childitem.amount | number:'0.0-0'}}</span>
            }
          }
        </a>
      </mat-list-item>
      }
    </mat-nav-list>
    }
  </mat-list-item>
  }
</mat-nav-list>